var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.954 6.155a.79.79 0 0 0-.788.789V17.61H4.809V6.944a.79.79 0 0 0-1.576 0v.746L1.928 6.368l3.2-2.865 1.862-.672a3.19 3.19 0 0 0 3.608 2.06 3.168 3.168 0 0 0 2.395-2.06l1.862.672 3.19 2.864-1.303 1.319v-.742a.79.79 0 0 0-.788-.789m3.823-.382-.02-.02L15.79 2.23a.784.784 0 0 0-.262-.159l-2.862-1.022a.79.79 0 0 0-1.057.714c-.003.065-.079 1.592-1.614 1.616-1.516-.024-1.63-1.464-1.639-1.63A.788.788 0 0 0 7.571 1l-.046.001a.788.788 0 0 0-.22.045L4.442 2.083a.781.781 0 0 0-.255.154L.246 5.753A.784.784 0 0 0 0 6.304c-.005.211.072.41.237.583l3.011 3.044v8.486a.79.79 0 0 0 .788.789h11.93a.79.79 0 0 0 .788-.789V9.931l3.002-3.035c.315-.3.328-.8.02-1.123",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.18b43160a6078a6c0ca1879c3b8b2e1f.svg";
export { ForwardRef as ReactComponent };